import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ServiceToLiteDto } from '@app/clients/shared/models/ServiceToLiteDto';

@Injectable({ providedIn: 'root' })
export class RegulatoryDataFilterService {
    private _selectedLocations = new BehaviorSubject<ServiceToLiteDto[]>(
        this.loadFromSession()
    );

    selectedLocations$ = this._selectedLocations.asObservable();

    get snapshot(): ServiceToLiteDto[] {
        return this._selectedLocations.getValue();
    }

    set(locations: ServiceToLiteDto[]): void {
        this._selectedLocations.next(locations);
        sessionStorage.setItem('RegulatoryDataSelectedLocations', JSON.stringify(locations));
    }

    clear(): void {
        this._selectedLocations.next([]);
        sessionStorage.removeItem('RegulatoryDataSelectedLocations');
    }

    private loadFromSession(): ServiceToLiteDto[] {
        try {
            const raw = sessionStorage.getItem('RegulatoryDataSelectedLocations');
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    }

}